import React, { Component } from "react";
import { Icon } from "@iconify/react";
import angularIcon from "@iconify/icons-logos/angular-icon";
import reactIcon from "@iconify/icons-logos/react";
import vueIcon from "@iconify/icons-logos/vue";
import "./About.scss";
import { 
  trackSectionView, 
  trackTimeOnSection 
} from "../utils/analytics";

class About extends Component {
  constructor(props) {
    super(props);
    this.sectionRef = React.createRef();
    this.sectionStartTime = null;
    this.hasTrackedView = false;
  }

  componentDidMount() {
    this.setupIntersectionObserver();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.trackTimeSpent();
  }

  setupIntersectionObserver = () => {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.sectionStartTime = Date.now();
            if (!this.hasTrackedView) {
              trackSectionView('about');
              this.hasTrackedView = true;
            }
          } else {
            this.trackTimeSpent();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (this.sectionRef.current) {
      this.observer.observe(this.sectionRef.current);
    }
  };

  trackTimeSpent = () => {
    if (this.sectionStartTime) {
      const timeSpent = Math.round((Date.now() - this.sectionStartTime) / 1000);
      if (timeSpent > 1) {
        trackTimeOnSection('about', timeSpent);
      }
      this.sectionStartTime = null;
    }
  };
  render() {
    if (this.props.sharedBasicInfo) {
      var profilepic = "images/" + this.props.sharedBasicInfo.image;
    }
    if (this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.about;
      var hello = this.props.resumeBasicInfo.description_header;
      var about = this.props.resumeBasicInfo.description;
    }

    return (
      <section className="about-section" id="about" ref={this.sectionRef}>
        <div className="container">
          <div className="about-header">
            <h2 className="section-title">About Me</h2>
            <div className="section-divider"></div>
          </div>

          <div className="about-content">
            <div className="about-card">
              <div className="about-text">
                <h3 className="about-greeting">{hello}</h3>
                <div className="about-description">{about}</div>

                <div className="about-highlights">
                  <div className="highlight-item">
                    <div className="highlight-icon">🚀</div>
                    <div className="highlight-content">
                      <h4>Passionate Developer</h4>
                      <p>Building amazing digital experiences</p>
                    </div>
                  </div>

                  <div className="highlight-item">
                    <div className="highlight-icon">💡</div>
                    <div className="highlight-content">
                      <h4>Creative Problem Solver</h4>
                      <p>Turning ideas into reality</p>
                    </div>
                  </div>

                  <div className="highlight-item">
                    <div className="highlight-icon">⚡</div>
                    <div className="highlight-content">
                      <h4>Performance Focused</h4>
                      <p>Optimized for speed and efficiency</p>
                    </div>
                  </div>
                </div>
              </div>

              {profilepic && (
                <img 
                  src={profilepic} 
                  alt="Portrait of Hiren Surani" 
                  loading="lazy" 
                  width="400" 
                  height="400" 
                  decoding="async" 
                  style={{ objectFit: 'contain' }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
